import { useEffect, useState } from "react";
import { tickerItems } from "@/mocks/gossip";

const navLinks = [
  { label: "今日热榜", href: "#hot" },
  { label: "明星八卦", href: "#star" },
  { label: "网红主播", href: "#streamer" },
  { label: "实锤档案", href: "#impact" },
  { label: "最新动态", href: "#news" },
  { label: "追瓜指南", href: "#guide" },
];

function BreakingTicker() {
  const joined = tickerItems.map((i) => `【${i.tag}】${i.text}`).join("　·　");
  return (
    <div className="flex items-center overflow-hidden border-b border-primary-100 bg-primary-600 text-background-50">
      <div className="flex shrink-0 items-center gap-1.5 bg-primary-600 px-3 py-1.5 md:px-4">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-300" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50" />
        </span>
        <span className="whitespace-nowrap text-[11px] font-bold tracking-widest md:text-xs">刚刚爆料 · 滚动快讯</span>
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="flex w-max animate-ticker whitespace-nowrap px-4 py-1.5 text-xs text-background-50/95 md:text-[13px]">
          <span>{joined}</span>
        </div>
      </div>
    </div>
  );
}

export default function TopNav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [kw, setKw] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50">
      <BreakingTicker />
      <nav className={`transition-colors duration-300 ${scrolled ? "bg-background-50/95 backdrop-blur" : "bg-background-50"}`}>
        <div className="mx-auto flex h-16 max-w-[1200px] items-center justify-between gap-4 px-4 md:px-6">
          {/* brand */}
          <a href="#top" className="group flex items-center gap-2.5">
            <span className="font-heading grid h-10 w-10 place-items-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-flashlight-fill text-lg" />
            </span>
            <span className="leading-none">
              <span className="font-heading block text-lg font-black tracking-tight text-primary-700">
                刚刚爆料
              </span>
              <span className="mt-1 block text-[10px] font-medium tracking-[0.18em] text-foreground-500">饭后追瓜 · 看这一页</span>
            </span>
          </a>

          {/* desktop nav */}
          <div className="hidden items-center gap-1 lg:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition hover:bg-secondary-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
          </div>

          {/* search + cta + burger */}
          <div className="flex items-center gap-2">
            <div className={`hidden items-center transition-all duration-300 md:flex ${searchOpen ? "w-56" : "w-10"}`}>
              {searchOpen ? (
                <form
                  className="flex w-full items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5"
                  onSubmit={(e) => {
                    e.preventDefault();
                    setKw("");
                    setSearchOpen(false);
                  }}
                >
                  <i className="ri-search-line text-sm text-foreground-500" />
                  <input
                    value={kw}
                    onChange={(e) => setKw(e.target.value)}
                    placeholder="搜瓜：人物 / 事件"
                    className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
                  />
                  <button type="submit" aria-label="搜索" className="text-primary-600">
                    <i className="ri-arrow-right-line" />
                  </button>
                </form>
              ) : (
                <button
                  type="button"
                  aria-label="展开搜索"
                  onClick={() => setSearchOpen(true)}
                  className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-600 transition hover:bg-secondary-100 hover:text-primary-700"
                >
                  <i className="ri-search-line text-lg" />
                </button>
              )}
            </div>

            <a
              href="#join"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-primary-600 sm:inline-flex"
            >
              订阅快讯
            </a>

            <button
              type="button"
              aria-label="菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-800 transition hover:bg-secondary-100 lg:hidden"
            >
              <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
            </button>
          </div>
        </div>

        {/* mobile panel */}
        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
            <div className="mb-3 flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2">
              <i className="ri-search-line text-foreground-500" />
              <input
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                placeholder="搜瓜：人物 / 事件"
                className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
              />
            </div>
            <div className="grid grid-cols-2 gap-2">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-lg bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-800 transition hover:bg-secondary-100 hover:text-primary-700"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}